import { ReportProfileAlertBaseModel } from '../profile/report-profile-alert-base-model';

export class UserReportProfileAlertAccessModesModel extends ReportProfileAlertBaseModel {
  invalidAccessModes: string[];
}
